module.exports = __webpack_public_path__ + "static/media/HFIL-USDT.19d9eee1.svg";